module.exports = __webpack_public_path__ + "img/115065.cf9a502c.png";